import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

export default class Pronunciation extends React.Component {

  static propTypes = {
    wordText: PropTypes.string,
    pronunciationFile: PropTypes.string
  }

  state = {
    play: false
  }

  render() {
    if (this.props.pronunciationFile) {
      return (
        <span>
          <a href='#' className='pronunciation-logo' onClick={ this.onPlay.bind(this) }>
            { this.renderIcon() }
          </a>
          { this.renderPlay() }
        </span>
      );
    } else {
      return null;
    }
  }

  renderIcon() {
    if (this.state.play) {
      return <FontAwesomeIcon icon={ faVolumeUp } size='lg'  />;
    } else {
      return <FontAwesomeIcon icon={ faVolumeUp } size='xs' />;
    }
  }

  renderPlay() {
    if (this.state.play) {
      return (
        <audio id={ `${this.props.wordText}-pronunciation` } src={ this.props.pronunciationFile } autoPlay onEnded={ this.onStop.bind(this) }/>
      );
    } else {
      return null;
    }
  }

  onPlay(event) {
    event.preventDefault();
    this.setState({ play: true });
  }

  onStop(event) {
    event.preventDefault();
    this.setState({ play: false });
  }
}



// WEBPACK FOOTER //
// ./src/components/pronunciation.jsx